import { Button } from '@capsule/consumer-design-system';

import styled from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { CardItem } from 'src/app/components/Elements/Card';
import { Typography } from 'src/app/components/Elements/Typography';
import { CTATypesToTextMap } from 'src/app/components/Models/Medication/utils';
import { formatPrice } from 'src/app/utils';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

const CardRowTextIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.space.s2};
  color: ${({ theme }) => theme.colors.capsuleBlue50};
  width: 100%;
`;

const TextContainer = styled(Typography)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.space.s5};
  margin-left: ${({ theme }) => theme.space.s5};
  margin-right: ${({ theme }) => theme.space.s5};
  margin-bottom: ${({ theme }) => theme.space.s5};
  white-space: pre-wrap;
`;

const StyledButton = styled(Button)`
  width: calc(100% - (${({ theme }) => theme.space.s5} * 2));
  margin: ${({ theme }) => theme.space.s5} auto;
`;

const CardItemWithReducedPadding = styled(CardItem)`
  &&& {
    background-color: transparent;
    padding: ${({ theme }) => theme.space.s2};
    left: ${({ theme }) => theme.space.s3};
    right: ${({ theme }) => theme.space.s3};
  }
`;

export const StylizedCapsuleIcon = styled(props => <CapsuleIcon {...props} />)`
  svg {
    width: ${props => props.theme.space.s5};
    height: ${props => props.theme.space.s5};
  }
`;

export const StylizedTypography = styled(Typography)`
  font-weight: bold !important;
`;

const NameAndPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

interface CardRescheduledItemProps {
  description: string;
  orderItems: { name: string; price?: number }[];
  onRescheduleClick: () => void;
  ctaType: string;
}

export const CardRescheduledDetailsItem = ({
  description,
  orderItems,
  onRescheduleClick,
  ctaType,
}: CardRescheduledItemProps) => {
  return (
    <>
      <TextContainer variant={'body'} color={'capsuleBlue50'}>
        <p>{description}</p>
      </TextContainer>
      {orderItems.map((orderItem, index) => {
        const { name, price } = orderItem;
        return (
          <CardItemWithReducedPadding key={`orderItem_${index}`} noDivider>
            <CardRowTextIconContainer>
              <StylizedCapsuleIcon iconString={CAPSULE_ICON_STRINGS.pill_bottle} block />
              <NameAndPriceContainer>
                <b>
                  <StylizedTypography variant={'body'} color={'capsuleBlue50'}>
                    {name}
                  </StylizedTypography>
                </b>
                {price && price !== null && (
                  <Typography variant={'small'} color={'capsuleGray50'}>
                    {formatPrice(price)}
                  </Typography>
                )}
              </NameAndPriceContainer>
            </CardRowTextIconContainer>
          </CardItemWithReducedPadding>
        );
      })}
      <StyledButton variant="contained-secondary-lg" isFullWidth onClick={onRescheduleClick}>
        {ctaType in CTATypesToTextMap ? CTATypesToTextMap[ctaType] : 'Reschedule Order'}
      </StyledButton>
    </>
  );
};
